const getRolesCount = (state) => {
  return state.main.roleState.count
}
const getFetchRolesCountRequestState = (state) => {
  return state.main.roleState.fetchRolesCountRequestState
}
const getUpdateRoleRequestState = (state) => {
  return state.main.roleState.updateRoleRequestState
}
const getFetchRolesRequestState = (state) => {
  return state.main.roleState.fetchRolesRequestState
}
const getRoles = (state) => {
  return state.main.roleState.roles
}
const getCreateRoleRequestState = (state) => {
  return state.main.roleState.createRoleRequestState
}
const getDeleteRoleRequestState = (state) => {
  return state.main.roleState.deleteRoleRequestState
}

const getAssignedAdmins = (state) => {
  return state.main.roleState.assignedAdmins
}
const getFetchRoleAdminListRequestState = (state) => {
  return state.main.roleState.fetchRoleAdminListRequestState
}
const getAssignedAdminsPaginationOffset = (state) => {
  return state.main.roleState.assignedAdminsPaginationOffset
}
const getRolesWithAdmins = (state) => {
  return state.main.roleState.rolesWithAdmins
}
const getFetchRolesWithAdminsRequestState = (state) => {
  return state.main.roleState.fetchRolesWithAdminsRequestState
}
const getRolesPaginationOffset = (state) => {
  return state.main.roleState.rolesPaginationOffset
}
const getAllRoles = (state) => {
  return state.main.roleState.allRoles
}
const getFetchAllRolesRequestState = (state) => {
  return state.main.roleState.fetchAllRolesRequestState
}
const getAllRolesPaginationOffset = (state) => {
  return state.main.roleState.allRolesPaginationOffset
}
const RoleSelectors = {
  getFetchRolesCountRequestState,
  getRolesCount,
  getUpdateRoleRequestState,
  getFetchRolesRequestState,
  getRoles,
  getCreateRoleRequestState,
  getDeleteRoleRequestState,
  getAssignedAdmins,
  getFetchRoleAdminListRequestState,
  getAssignedAdminsPaginationOffset,
  getRolesWithAdmins,
  getFetchRolesWithAdminsRequestState,
  getRolesPaginationOffset,
  getAllRoles,
  getFetchAllRolesRequestState,
  getAllRolesPaginationOffset,
}

export default RoleSelectors
